if (!$('#uber').hasClass('moduleInterior')) {
    if (iCreateObject.isSiteInICreateMode) {
        var toggleHtmlStructure = '<div class="toggleContent cf">';

        if ($('#subNavWrapper').length > 0) {
            toggleHtmlStructure += '<label for="chkHideLeftContent" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideLeftContent" type="checkbox" name="chkHideLeftContent" />Hide Sidebar</label>';
        }

        if ($('#subNavContainer').length > 0) {
            toggleHtmlStructure += '<label for="chkHideSubNav" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideSubNav" type="checkbox" name="chkHideSubNav" />Hide Sub Nav</label>';
        }

        if ($('#uber:not(.blogFeed) #intBgImage').length > 0) {
            toggleHtmlStructure += '<label for="chkHideBannerImage" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideBannerImage" type="checkbox" name="chkHideBannerImage" />Hide Banner Image</label>';
        }

        if ($('#contactMainContainer').length > 0) {
            toggleHtmlStructure += '<label for="chkHideRightContact" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideRightContact" type="checkbox" name="chkHideRightContact" />Hide Contact</label>';
        }

        if ($('#featureImageHolder').length > 0) {
            toggleHtmlStructure += '<label for="chkHideFeatureImage" class="ic-checkbox-inline">';
            toggleHtmlStructure += '<input id="chkHideFeatureImage" type="checkbox" name="chkHideFeatureImage" />Hide Feature Image</label>';
        }

        toggleHtmlStructure += '<label for="chkHideEmergencyAlert" class="ic-checkbox-inline">';
        toggleHtmlStructure += '<input id="chkHideEmergencyAlert" type="checkbox" name="chkHideEmergencyAlert" />Hide Emergency Alert</label>';

        toggleHtmlStructure += '</div>';

        $('#printArea').before(toggleHtmlStructure);
    }

    if ($('#TKInteriorHideAreasToggle #frmToggleContent').length <= 0) {
        var myForm = $('<form>');
        myForm.attr({ 'id': 'frmToggleContent', 'action': '#' });

        if ($('#subNavWrapper').length > 0) {
            myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideLeftContent', 'value': $('#uber').hasClass('wide') ? 'wide' : '' }));
        }

        if ($('#subNavContainer').length > 0) {
            myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideSubNav', 'value': $('#subNavContainer').hasClass('hide') ? 'hide' : '' }));
        }

        if ($('#uber:not(.blogFeed) #intBgImage').length > 0) {
            myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideBannerImage', 'value': $('#uber').hasClass('hideBanner') ? 'hideBanner' : '' }));
        }

        if ($('#contactMainContainer').length > 0) {
            myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideRightContact', 'value': $('#contactMainContainer').hasClass('hide') ? 'hide' : '' }));
        }

        if ($('#featureImageHolder').length > 0) {
            myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideFeatureImage', 'value': $('#featureImageHolder').hasClass('hide') ? 'hide' : '' }));
        }

        myForm.append($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideEmergencyAlert', 'value': '' }));
        myForm.append($('<input>').attr({ 'type': 'submit', 'id': 'btnToggleContent', 'name': 'btnToggleContent', 'aria-label': 'Toggle Content' }).addClass('hideButton'));

        $('#TKInteriorHideAreasToggle').empty().append(myForm);
    } else {
        //Insert emergency alert banner if not already there
        if ($('#TKInteriorHideAreasToggle #frmToggleContent #hdnHideEmergencyAlert').length <= 0) {
            $('#TKInteriorHideAreasToggle #frmToggleContent').prepend($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideEmergencyAlert', 'value': '' }));
        }

        //Insert subnav if not already there
        if ($('#TKInteriorHideAreasToggle #frmToggleContent #hdnHideSubNav').length <= 0) {
            $('#TKInteriorHideAreasToggle #frmToggleContent').prepend($('<input>').attr({ 'type': 'hidden', 'id': 'hdnHideSubNav', 'value': '' }));
        }
    }

    // bind checkbox with hidden fields
    //Emergency Banner
    if (($('#hdnHideEmergencyAlert').length > 0) && ($('#hdnHideEmergencyAlert').val() === 'hide')) {
        if ($('#chkHideEmergencyAlert').length > 0) {
            $('#chkHideEmergencyAlert').attr('checked', 'checked');
        }
    }

    //Side Panel
    if ($('#subNavWrapper').length > 0 && ($('#hdnHideLeftContent').length > 0) && ($('#hdnHideLeftContent').val() === 'wide')) {
        if ($('#chkHideLeftContent').length > 0) {
            $('#chkHideLeftContent').attr('checked', 'checked');
        }

        $('#uber').toggleClass('wide', true);
        $('#subNavWrapper').toggleClass('wide', true);
    } else if ($('#subNavWrapper').length > 0 && ($('#hdnHideLeftContent').length > 0) && ($('#hdnHideLeftContent').val() === '')) {
        $('#uber').toggleClass('wide', false);
        $('#subNavWrapper').toggleClass('wide', false);
    }

    //Subnav
    if ($('#subNavContainer').length > 0 && ($('#hdnHideSubNav').length > 0) && ($('#hdnHideSubNav').val() === 'hide')) {
        if ($('#chkHideSubNav').length > 0) {
            $('#chkHideSubNav').attr('checked', 'checked');
        }

        $('#subNavContainer').toggleClass('hide', true);
    } else if ($('#subNavContainer').length > 0 && ($('#hdnHideSubNav').length > 0) && ($('#hdnHideSubNav').val() === '')) {
        $('#subNavContainer').toggleClass('hide', false);
    }

    //Interior Banner
    if ($('#intBgImage').length > 0 && ($('#hdnHideBannerImage').length > 0) && ($('#hdnHideBannerImage').val() === 'hideBanner')) {
        if ($('#chkHideBannerImage').length > 0) {
            $('#chkHideBannerImage').attr('checked', 'checked');
        }
        $('#uber').toggleClass('hideBanner', true);
    } else if ($('#intBgImage').length > 0 && ($('#hdnHideBannerImage').length > 0) && ($('#hdnHideBannerImage').val() === '')) {
        $('#uber').toggleClass('hideBanner', false);
    }

    //Contact
    if (($('#hdnHideRightContact').length > 0) && ($('#hdnHideRightContact').val() === 'hide')) {
        if ($('#chkHideRightContact').length > 0) {
            $('#chkHideRightContact').attr('checked', 'checked');
        }

        $('#contactMainContainer').toggleClass('hide', true);
    } else if (($('#hdnHideRightContact').length > 0) && ($('#hdnHideRightContact').val() === '')) {
        $('#contactMainContainer').toggleClass('hide', false);
    }

    //Feature Image
    if (($('#hdnHideFeatureImage').length > 0) && ($('#hdnHideFeatureImage').val() === 'hide')) {
        if ($('#chkHideFeatureImage').length > 0) {
            $('#chkHideFeatureImage').attr('checked', 'checked');
        }

        $('#featureImageHolder').toggleClass('hide', true);
    } else if (($('#hdnHideFeatureImage').length > 0) && ($('#hdnHideFeatureImage').val() === '')) {
        $('#featureImageHolder').toggleClass('hide', false);
    }

    // bind checkbox change event
    //Emergency Banner
    if ($('#chkHideEmergencyAlert').length > 0) {
        $('#chkHideEmergencyAlert').change(function () {
            $('#hdnHideEmergencyAlert').val($('#chkHideEmergencyAlert:checked').length > 0 ? 'hide' : '');

            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();
            }
        });
    }

    //Side Panel
    if ($('#subNavWrapper').length > 0 && $('#chkHideLeftContent').length > 0) {
        $('#chkHideLeftContent').change(function () {
            $('#uber').toggleClass('wide', $(this).is(':checked'));
            $('#subNavWrapper').toggleClass('wide', $(this).is(':checked'));
            $('#hdnHideLeftContent').val($('#subNavWrapper').hasClass('wide') ? 'wide' : '');

            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();
            }
        });
    }
    //Subnav
    if ($('#subNavContainer').length > 0 && $('#chkHideSubNav').length > 0) {
        $('#chkHideSubNav').change(function () {
            $('#subNavContainer').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideSubNav').val($('#subNavContainer').hasClass('hide') ? 'hide' : '');

            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();
            }
        });
    }

    //Interior Banner
    if ($('#intBgImage').length > 0 && $('#chkHideBannerImage').length > 0) {
        $('#chkHideBannerImage').change(function () {
            $('#uber').toggleClass('hideBanner', $(this).is(':checked'));
            $('#hdnHideBannerImage').val($('#uber').hasClass('hideBanner') ? 'hideBanner' : '');

            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();
            }
        });
    }

    //Contact
    if ($('#chkHideRightContact').length > 0) {
        $('#chkHideRightContact').change(function () {
            $('#contactMainContainer').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideRightContact').val($('#contactMainContainer').hasClass('hide') ? 'hide' : '');

            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();
            }
        });
    }

    //Feature Image
    if ($('#chkHideFeatureImage').length > 0) {
        $('#chkHideFeatureImage').change(function () {
            $('#featureImageHolder').toggleClass('hide', $(this).is(':checked'));
            $('#hdnHideFeatureImage').val($('#featureImageHolder').hasClass('hide') ? 'hide' : '');

            if (iCreateObject.isSiteInICreateMode) {
                $('#TKInteriorHideAreasToggle').save();

            }
        });
    }
}
